
/**
 * @description
 * 수업의 스케줄 준비중 / 전석 매진 상태 표기를 위한 태그 컴포넌트
 */

export default {
  name: 'ScheduleStatusTag',
  props: {
    isFull: { type: Boolean, default: false },
    hasSchedule: { type: Boolean, default: true },
    outlined: { type: Boolean, default: false },
  },
  data() {
    return {
      timer: 0,
      intervalTimer: null,
    };
  },
  computed: {
    // 우선순위 = 매진 / 준비중
    statusText: ({ isFull, hasSchedule }) => {
      if (isFull) return '전석 매진';
      if (!hasSchedule) return '스케줄 준비중';
      return null;
    },
  },
};
